<script>
  import { onMount, tick } from "svelte"
  import DialogBase2 from "../../../../components/dialog/DialogBase2.svelte";
  import ApplyLicenseFileDialogContent from "./ApplyLicenseFileDialogContent.svelte";

  export let onClose

  let dialog

  function handleClose() {
    dialog?.close()
    onClose()
  }

  onMount(async () => {
    await tick()
    dialog.showModal()
  })
</script>

<DialogBase2 bind:dialog={dialog}>
  <ApplyLicenseFileDialogContent onClose={handleClose}/>
</DialogBase2>
